import { styled } from '@mui/material/styles';
import MuiTooltip from '@mui/material/Tooltip';

export const StyledTooltip = styled(MuiTooltip)({}) as typeof MuiTooltip;
